import { type QuizBankSearchReq } from '@/api/quizBank';

import { QUIZ_BANK_SORT_TO_SERVER } from '../consts';
import { type QuizBankFilterState } from '../types';

interface ToSearchReqParams {
  categoryTreeId: string;
  filter: QuizBankFilterState;
  limit: number;
  cursor?: string;
}

/**
 * 필터 상태 → 서버 요청.
 *
 * `schoolGrades` 는 3분기라 조건부로 빼면 안 된다:
 * 미전송 = 카테고리의 학년 하나 · `[]` = 전체 학년 · `["01"]` = 그 학년.
 */
export const toQuizBankSearchReq = ({
  categoryTreeId,
  filter,
  limit,
  cursor,
}: ToSearchReqParams): QuizBankSearchReq => ({
  categoryFilters: {
    categoryTreeId,
    schoolGrades: filter.gradeId ? [filter.gradeId] : [],
  },
  ...(filter.unitIds.length > 0 && { unitIds: filter.unitIds }),
  ...(filter.types.length > 0 && { quizTypes: filter.types }),
  ...(filter.query.trim() && { keyword: filter.query.trim() }),
  sort: QUIZ_BANK_SORT_TO_SERVER[filter.sort],
  ...(cursor && { cursor }),
  limit,
});
